import React from 'react'
import DemosPage from './pages/DemosPage'
import LoginPage from './pages/login/Login'
import HomePage from './pages/HomePage'
import PrivacyPolicyPage from './pages/demos/PrivacyPolicyPage'
import AvatarDemosPage from './pages/AvatarDemosPage'
import AvatarPlaygroundPage from './pages/playground-avatar/AvatarPlaygroundPage'
import StoryTellPage from './pages/demos/StoryTellPage'
import ScattergoriesPage from './pages/demos/ScattergoriesPage'

export type Alignment = 'default' | 'bottom'

export enum RoutePath {
  LOGIN = '/login',
  HOME = '/',
  DEMOS = '/demos',
  AVATAR_DEMOS = '/demos/avatar-demos',
  
  // Demos
  PRIVACY_POLICY = '/demos/privacy-policy?',
  STORY_TELL = '/demos/story-tell?',
  SCATTERGORIES = '/demos/scattergories?',

  AVATAR_PLAYGROUND = '/games/:gameId/components/:componentId/avatar-playground/:conversationId?',
  AVATAR_PLAYGROUND2 = '/games/:gameId/components/:componentId/avatar-playground2/:conversationId?',
}

export const routes: Route[] = [
  {
    name: 'home',
    path: RoutePath.HOME,
    component: HomePage,
  },
  {
    name: 'login',
    path: RoutePath.LOGIN,
    component: LoginPage,
  },
  {
    name: 'avatar-playground',
    path: RoutePath.AVATAR_PLAYGROUND,
    component: AvatarPlaygroundPage,
  },
  {
    name: 'avatar-playground2',
    path: RoutePath.AVATAR_PLAYGROUND2,
    component: AvatarPlaygroundPage,
  },
  {
    name: 'demos',
    path: RoutePath.DEMOS,
    component: DemosPage,
  },
  {
    name: 'avatar-demos',
    path: RoutePath.AVATAR_DEMOS,
    component: AvatarDemosPage,
  },
  {
    name: 'privacy-policy',
    path: RoutePath.PRIVACY_POLICY,
    component: PrivacyPolicyPage,
  },
  {
    name: 'story-tell',
    path: RoutePath.STORY_TELL,
    component: StoryTellPage,
  },
  {
    name: 'scattergories',
    path: RoutePath.SCATTERGORIES,
    component: ScattergoriesPage,
  },
]

export interface Route {
  name: string
  path: string
  component: React.ComponentType
}
